import React from 'react';
import { useTranslation } from 'react-i18next';
import PermMediaOutlinedIcon from '@mui/icons-material/PermMediaOutlined';

import MultipleUploadMedia from '../multiple-media-upload/MultipleUploadMedia';
import TooltipButton from '../../../components/tooltip-button/TooltipButton';
import Icon from '../../../icons/Icon';
import { BUTTON_STYLES } from '../../../components/common-button/CommonButton';
import useCommonModal from '../../../hooks/useCommonModal';

function UploadButton() {
  const { t } = useTranslation('activ8');

  const {
    isOpen: isOpenMultipleUploadMedia,
    handleOpenModal: handleOpenMultipleUploadMedia,
    handleCloseModal: handleCloseMultipleUploadMedia,
  } = useCommonModal();

  return (
    <>
      <TooltipButton onClick={handleOpenMultipleUploadMedia} styleColor={BUTTON_STYLES.PRIMARY} maxWidth={144}>
        <Icon icon={PermMediaOutlinedIcon} />
        {t('uploadMedia')}
      </TooltipButton>

      <MultipleUploadMedia isOpen={isOpenMultipleUploadMedia} onClose={handleCloseMultipleUploadMedia} />
    </>
  );
}

export default UploadButton;
